/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CancelPimImportMutationVariables = Types.Exact<{
  input: Types.DeletePimImportInput;
}>;


export type CancelPimImportMutation = { deletePimImport: { __typename: 'DeletePimImportationResult', importation: { __typename: 'PimImportation', id: string, url: string, status: Types.PimImportationStatus, filename: string } } };


export const CancelPimImportDocument = gql`
    mutation CancelPimImport($input: DeletePimImportInput!) {
  deletePimImport(input: $input) {
    importation {
      id
      url
      status
      filename
    }
  }
}
    `;
export type CancelPimImportMutationFn = Apollo.MutationFunction<CancelPimImportMutation, CancelPimImportMutationVariables>;

/**
 * __useCancelPimImportMutation__
 *
 * To run a mutation, you first call `useCancelPimImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPimImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPimImportMutation, { data, loading, error }] = useCancelPimImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelPimImportMutation(baseOptions?: Apollo.MutationHookOptions<CancelPimImportMutation, CancelPimImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPimImportMutation, CancelPimImportMutationVariables>(CancelPimImportDocument, options);
      }
export type CancelPimImportMutationHookResult = ReturnType<typeof useCancelPimImportMutation>;
export type CancelPimImportMutationResult = Apollo.MutationResult<CancelPimImportMutation>;
export type CancelPimImportMutationOptions = Apollo.BaseMutationOptions<CancelPimImportMutation, CancelPimImportMutationVariables>;